export default "__VITE_ASSET__B1GFC3Xs__"